<ng-container *transloco="let t">
    <!-- Breadcrumb -->
    <div class="breadcrumb-card mb-25 d-md-flex align-items-center justify-content-between">
        <h5 class="mb-0">
            {{t('vulnerabilities')}}
        </h5>
        <ol class="breadcrumb list-unstyled mt-0 mb-0 pl-0">
            <li class="breadcrumb-item position-relative">
                {{t('ASM')}}
            </li>
            <li class="breadcrumb-item position-relative">
                {{t('vulnerabilities')}}
            </li>
        </ol>
    </div>
    @if (isLoadingResults || isRateLimitReached) {
    <div class="loading-shade">
        @if (isLoadingResults) {
        <mat-spinner></mat-spinner>
        }
        @if (isRateLimitReached) {
        <div class="rate-limit-reached">
            ALTAIR rate limit has been reached. It will be reset in one minute.
        </div>
        }
    </div>
    }
    <!-- Vulnerabilities -->
    <mat-card class="altair-card companies-card mb-25 border-radius bg-white border-none d-block"
        [class.rtl-enabled]="themeService.isRTLEnabled()">
        <mat-card-header>
            <mat-card-title>
                <form class="search-box position-relative">
                    <i class="material-symbols-outlined">
                        search
                    </i>
                    <input matInput class="input-search d-block w-100 border-none outline-0"
                        placeholder="{{t('search')}} {{t('vulnerability')}}..." (keyup)="applyFilter($event)"
                        (keydown.enter)="onKeydown($event)" #input>
                </form>
            </mat-card-title>
        </mat-card-header>
        <mat-card-content>
            <div class="companies-table">
                <div class="table-responsive">
                    <table mat-table [dataSource]="dataSource">

                        <!-- Source Column -->
                        <ng-container matColumnDef="source">
                            <th mat-header-cell *matHeaderCellDef>
                                {{t('source')}}
                            </th>
                            <td mat-cell *matCellDef="let row">
                                <span class="badge text-outline-primary">&nbsp;&nbsp;{{row.source.toUpperCase()}}&nbsp;&nbsp;</span>
                            </td>
                        </ng-container>

                        <!-- Title Column -->
                        <ng-container matColumnDef="title">
                            <th mat-header-cell *matHeaderCellDef>
                                {{t('title')}}
                            </th>
                            <td mat-cell *matCellDef="let row">
                                <span class="badge text-soft-primary">&nbsp;&nbsp;{{row.name.toUpperCase()}}&nbsp;&nbsp;</span>
                            </td>
                        </ng-container>

                        <!-- Severity Column -->
                        <ng-container matColumnDef="severity">
                            <th mat-header-cell *matHeaderCellDef>
                                {{t('severity')}}
                            </th>
                            <td mat-cell *matCellDef="let row">
                                @if (row.severity == 'Info') {
                                <span class='badge text-soft-primary'>&nbsp;&nbsp;INFO&nbsp;&nbsp;</span>
                                }
                                @else if (row.severity == 'Low') {
                                <span class='badge text-soft-warning'>&nbsp;&nbsp;LOW&nbsp;&nbsp;</span>
                                }
                                @else if (row.severity == 'Medium') {
                                <span class='badge text-bg-warning'>&nbsp;&nbsp;MEDIUM&nbsp;&nbsp;</span>
                                }
                                @else if (row.severity == 'High') {
                                <span class='badge text-soft-danger'>&nbsp;&nbsp;HIGH&nbsp;&nbsp;</span>
                                }
                                @else if (row.severity == 'Critical') {
                                <span class='badge text-bg-danger'>&nbsp;&nbsp;CRITICAL&nbsp;&nbsp;</span>
                                }
                                @else if (row.severity == 'Unknown') {
                                <span class='badge text-soft-info'>&nbsp;&nbsp;UNKNOWN&nbsp;&nbsp;</span>
                                }
                            </td>
                        </ng-container>

                        <!-- VulnerableUrl Column -->
                        <ng-container matColumnDef="vulnerableUrl">
                            <th mat-header-cell *matHeaderCellDef>
                                {{t('vulnerable-url')}}
                            </th>
                            <td mat-cell *matCellDef="let row">
                                <a href="{{row.http_url}}" class="text-danger" target="_blank">{{row.http_url}}</a>
                            </td>
                        </ng-container>

                        <!-- Status Column -->
                        <ng-container matColumnDef="status">
                            <th mat-header-cell *matHeaderCellDef>
                                {{t('status')}}
                            </th>
                            <td mat-cell *matCellDef="let row">
                                @if (row.open_status) {
                                <span class="badge text-soft-danger">&nbsp;&nbsp;{{t('open')}}&nbsp;&nbsp;</span>
                                }
                                @else{
                                <span class="badge text-soft-success">&nbsp;&nbsp;{{t('resolved')}}&nbsp;&nbsp;</span>
                                }
                            </td>
                        </ng-container>

                        <!-- Action Column -->
                        <ng-container matColumnDef="action">
                            <th mat-header-cell *matHeaderCellDef>
                                {{t('action')}}
                            </th>
                            <td mat-cell *matCellDef="let row">

                            </td>
                        </ng-container>

                        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                        <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>

                        <!-- Row shown when there is no matching data. -->
                        <tr class="mat-row" *matNoDataRow>
                            <td class="mat-cell" colspan="4">{{t('no-data-matching')}} "{{input.value}}"</td>
                        </tr>

                    </table>
                </div>
                <mat-paginator [pageSizeOptions]="pageSizes" showFirstLastButtons></mat-paginator>
            </div>
        </mat-card-content>
    </mat-card>
</ng-container>
